export default {
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  ACCESS_MANAGEMENT: '/',
};
